(function() {
  exports.BaseOutput = (function() {
    function BaseOutput(parent, dialog, width, dtOpts, auxOpts) {
      if (width == null) {
        width = 'auto';
      }
      if (dtOpts == null) {
        dtOpts = {};
      }
      if (auxOpts == null) {
        auxOpts = {};
      }
      this.parent = parent;
      this.dialog = dialog;
      this.width = width;
      this.tables = [];
      this.auxTables = [];
      this.dtOptions = {
        sScrollY: '200px',
        bDestroy: true,
        bPaginate: false,
        bFilter: false,
        bInfo: false,
        bSort: false
      };
      this.dtAuxOptions = {
        bDestroy: true,
        bPaginate: false,
        bFilter: false,
        bInfo: false,
        bSort: false
      };
      this.dtOptions = $.extend(this.dtOptions, dtOpts);
      this.dtAuxOptions = $.extend(this.dtAuxOptions, auxOpts);
    }

    BaseOutput.prototype.buildTable = function() {
      var i, j, len, len1, ref, ref1, table;
      this.dialog.dialog.find('.tab-content').removeClass('overflow-hidden');
      this.dialog.dialog.find('.tab-content').width(this.width);
      if (this.dialog.dialog.find('.createDT.scrollDT').length > 0) {
        this.tables = this.dialog.dialog.find('.createDT.scrollDT').find('.table');
        ref = this.tables;
        for (i = 0, len = ref.length; i < len; i++) {
          table = ref[i];
          $(table).dataTable(this.dtOptions);
        }
      } else {
        this.tables = [];
      }
      if (this.dialog.dialog.find('.createDT').not('scrollDT').length > 0) {
        this.auxTables = this.dialog.dialog.find('.createDT').not('.scrollDT').find('.table');
        ref1 = this.auxTables;
        for (j = 0, len1 = ref1.length; j < len1; j++) {
          table = ref1[j];
          $(table).dataTable(this.dtAuxOptions);
        }
      } else {
        this.auxTables = [];
      }
      return this.dialog.resize();
    };

    BaseOutput.prototype.destroy = function() {
      return this.dialog.dialog.find('.tab-content').width('auto');
    };

    BaseOutput.prototype.resizeTable = function() {
      var dtsb_parent, h, i, len, ns, ref, results, scrollDT, size, table;
      ref = this.tables;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        table = ref[i];
        table = $(table);
        dtsb_parent = table.closest('.tab-content');
        scrollDT = table.closest('.scrollDT');
        if (this.tables.length > 1) {
          h = dtsb_parent.height();
          ns = (h / this.tables.length) - (5 * this.tables.length);
          scrollDT.resizr({
            new_size: ns
          });
        } else {
          scrollDT.resizr();
        }
        scrollDT.find('.dataTables_wrapper').resizr();
        scrollDT.find('.dataTables_scroll').resizr();
        scrollDT.find('.dataTables_scrollBody').resizr();
        table = table.dataTable();
        if ((table != null ? table.fnSettings() : void 0) != null) {
          size = scrollDT.find('.dataTables_scrollBody').resizr('resize') - 20;
          table.fnSettings().oScroll.sY = size + "px";
          results.push(table.fnAdjustColumnSizing(false));
        } else {
          results.push(void 0);
        }
      }
      return results;
    };

    return BaseOutput;

  })();

}).call(this);
